
import { ICoordinates, LocalizationPath } from '@tokyojob/core'
import { ButtonFactory, CButton, CLoader, getLocalization, IconPlacement, IconSize } from '@tokyojob/frontend-components'
import { LocalizationService } from '@tokyojob/frontend-core'
import { GeolocationErrorHandler } from './geolocation-error-handler'
import { defineComponent, ref } from 'vue'
import { getProvidedApp } from '~/base/utils/provided-getter'

const positionErrorEvent = 'positionError'
const gpsErrorHandler = new GeolocationErrorHandler()

export default defineComponent({
  components: {
    CButton,
    CLoader
  },
  props: {
    /**
     * Check if user is on mobile
     */
    isMobile: {
      type: Boolean,
      required: true
    }
  },
  setup(props, { emit }) {
    const localization = getLocalization(getProvidedApp())
    const buttonProperties = ButtonFactory.button({
      icon: { icon: 'location-crosshairs', placement: IconPlacement.Left, size: IconSize.large },
      label: LocalizationService.t<string>(localization, LocalizationPath.mapPageFindMyLocation),
      width: 'fit-content',
      height: '100%',
      classes: 'row-between align-center g-10 p-10 theme-blue-dark1-color btn-lg no-wrap'
    })
    const loadingOverlay = ref(null) as any
    function getCenterPoint() {
      if (navigator.geolocation) {
        loadingOverlay.value.show()
        try {
          navigator.geolocation.getCurrentPosition(
            (position) => {
              const coordinates = {
                lat: position.coords.latitude,
                lng: position.coords.longitude
              } as ICoordinates
              emit('updateCenterCoordinates', coordinates)
              loadingOverlay.value.hide()
            },
            (e) => {
              ;loadingOverlay.value.hide()
              const msg = gpsErrorHandler.getMessage(e, props.isMobile)
              console.log(msg)
              emit(positionErrorEvent, msg)
            }
          )
        } catch (e) {
          loadingOverlay.value.hide()
          console.log('Unexpected error, please try again.')
          emit(positionErrorEvent, 'Unexpected error, please try again.')
        }
      } else {
        console.log('The browser does not support location services')
        emit(positionErrorEvent, 'The browser does not support location services')
      }
    }
    return {
      buttonProperties,
      isLoading: false,
      getCenterPoint,
      loadingOverlay
    }
  }
})
